import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-rating-level-selector',
  templateUrl: './rating-level-selector.component.html',
  styleUrls: ['./rating-level-selector.component.scss']
})
export class RatingLevelSelectorComponent implements OnInit {

  @Output() levelSelected: EventEmitter<number> = new EventEmitter();

  public levels: ILevels[];
  public valueSelected: number;

  constructor() { 
    this.levels = [
      {
        icon: 'very-happy',
        label: 'Muy fácil',
        value: 5,
      },
      {
        icon: 'happy',
        label: 'Fácil',
        value: 4,
      },
      {
        icon: 'neutro',
        label: 'Ni fácil ni difícil',
        value: 3,
      },
      {
        icon: 'angry',
        label: 'Difícil',
        value: 2,
      },
      {
        icon: 'very-angry',
        label: 'Muy difícil',
        value: 1,
      }
    ]
  }

  ngOnInit() {
  }

  selectOption(value: number) : void {
    this.valueSelected = value;
    
    this.levelSelected.emit(this.valueSelected);
  }
}

interface ILevels {
  icon: string;
  label: string;
  value: number;
}